import { render, staticRenderFns } from "./EventParticipantsWidget.vue?vue&type=template&id=293a91a0&scoped=true&"
import script from "./EventParticipantsWidget.vue?vue&type=script&lang=js&"
export * from "./EventParticipantsWidget.vue?vue&type=script&lang=js&"
import style0 from "./EventParticipantsWidget.vue?vue&type=style&index=0&id=293a91a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293a91a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VProgressCircular})
